"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CarFormStep = exports.TpmsEnum = void 0;
var TpmsEnum;
(function (TpmsEnum) {
    TpmsEnum["NO_TPMS"] = "noTpms";
    TpmsEnum["HAS_TPMS"] = "hasTpms";
})(TpmsEnum = exports.TpmsEnum || (exports.TpmsEnum = {}));
var CarFormStep;
(function (CarFormStep) {
    CarFormStep[CarFormStep["Brand"] = 0] = "Brand";
    CarFormStep[CarFormStep["Type"] = 1] = "Type";
    CarFormStep[CarFormStep["Model"] = 2] = "Model";
})(CarFormStep = exports.CarFormStep || (exports.CarFormStep = {}));
;
